import { Box } from '@mui/material';
import { User } from 'firebase/auth';
import React from 'react';
import { auth as _auth } from '../firebase';

const AuthContext = React.createContext<{ auth: User | null, loading: boolean }>(
  {auth: null, loading: true}
);

export function useAuthContext() {
  return React.useContext(AuthContext);
}

export function AuthProvider({ children }: React.HTMLAttributes<Element>) {
  const [auth, setAuth] = React.useState<User | null>(null);
  const [loading, setLoading] = React.useState(true);
  const value = {auth, loading}

  React.useEffect(() => {
    const unsubscribed = _auth.onAuthStateChanged((user) => {
      setAuth(user);
      setLoading(false);
    });
    return () => {
      unsubscribed();
    };
  }, []);

  if (loading) {
    return (<Box sx={{height: '100vh', width: '100vw', backgroundColor: 'background.de'}}></Box>)
  } else {
    return (
      <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
    );
  }
}
